var learMoreUrl="https://support.wix.com/en/article/adding-link-rel-attributes";export{learMoreUrl};
//# sourceMappingURL=consts.js.map
